module.exports = __webpack_public_path__ + "logo-orkla-tagline-no-da8c3055c403c41423d0195f4a1ac2af.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/logo-orkla-tagline-no.svg
// module id = 69
// module chunks = 0